var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',{staticClass:"subtitle-1 pt-2 pb-0 d-flex justify-space-between"},[_c('span',[_vm._v(_vm._s(_vm.title)+" ")]),_vm._t("controls")],2),_c('v-card-text',{class:_vm.containerClasses},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }